import { on } from 'delegated-events'

on('click', '.integrations-item-premium', e => {
  e.preventDefault()
})
